import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EMPTY, Observable, catchError, take, tap } from "rxjs";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { createErrorObject } from "@webapp/error-handling/error-util";
import { KpiProjectionsFacade } from "@webapp/kpis/services/kpi-projections/kpi-projections-facade.service";
import { KpiDetailsStateService } from "../../services/kpi-details-state.service";

@Injectable()
export class KpiChartUtilsService {
  constructor(
    private kpiProjectionFacade: KpiProjectionsFacade,
    private kpiDetailsService: KpiDetailsStateService,
    private uiErrorHandlingService: UIErrorHandlingService
  ) {}

  public deleteProjection$(kpiId: string, projectionId: string, onError: () => void): Observable<void> {
    return this.kpiProjectionFacade.deleteProjection$(kpiId, projectionId).pipe(
      take(1),
      catchError((error) => {
        this.handleError(error);
        onError();
        return EMPTY;
      }),
      tap(() => this.kpiDetailsService.fetchKpiProjections(kpiId))
    );
  }

  private handleError(error: HttpErrorResponse): void {
    this.uiErrorHandlingService.handleModal(createErrorObject(error));
  }
}
